import { TimelineMax } from 'gsap';
import { random } from 'lodash';

const LoaderDate = (element) => {
  const letters = Array.from(element.querySelectorAll('.date span'));
  const chars = [
    'L', '0', 'V', '3',
  ];
  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start');

  tl.set(letters[0], { innerText: chars[random(0, chars.length - 1)] });
  tl.set(letters[1], { innerText: chars[random(0, chars.length - 1)] });
  tl.set(letters[2], { innerText: chars[random(0, chars.length - 1)] });
  tl.set(letters[3], { innerText: chars[random(0, chars.length - 1)] });
  tl.set(letters[4], { innerText: chars[random(0, chars.length - 1)] });
  tl.set(letters[5], { innerText: chars[random(0, chars.length - 1)] });
  tl.set(letters[6], { innerText: chars[random(0, chars.length - 1)] });
  tl.set(letters[7], { innerText: chars[random(0, chars.length - 1)] });

  tl.set(letters[0], { innerText: 'V' }, '+=1');
  tl.set(letters[1], { innerText: 'I' }, '+=0.1');
  tl.set(letters[2], { innerText: 'O' }, '+=0.1');
  tl.set(letters[3], { innerText: 'L' }, '+=0.1');
  tl.set(letters[4], { innerText: 'E' }, '+=0.1');
  tl.set(letters[5], { innerText: 'N' }, '+=0.1');
  tl.set(letters[6], { innerText: 'C' }, '+=0.1');
  tl.set(letters[7], { innerText: 'E' }, '+=0.1');

  tl.addLabel('random');

  for (let i = 0; i < 5; i += 1) {
    tl.staggerTo(letters, 0, {
      cycle: {
        innerText: () => chars[random(0, chars.length - 1)],
      },
    }, 0.1, `random+=${1 + (0.1 * i)}`);
  }

  tl.set(letters[0], { innerText: 'L' });
  tl.set(letters[1], { innerText: 'O' }, '+=0.1');
  tl.set(letters[2], { innerText: 'V' }, '+=0.1');
  tl.set(letters[3], { innerText: 'E' }, '+=0.1');
  tl.set(letters[4], { innerText: '0' }, '+=0.1');
  tl.set(letters[5], { innerText: '0' }, '+=0.1');
  tl.set(letters[6], { innerText: '0' }, '+=0.1');
  tl.set(letters[7], { innerText: '0' }, '+=0.1');

  tl.set(letters[0], { innerText: '0' }, '+=1');
  tl.set(letters[1], { innerText: '3' }, '+=0.1');
  tl.set(letters[2], { innerText: '0' }, '+=0.1');
  tl.set(letters[3], { innerText: '4' }, '+=0.1');
  tl.set(letters[4], { innerText: '2' }, '+=0.1');
  tl.set(letters[5], { innerText: '0' }, '+=0.1');
  tl.set(letters[6], { innerText: '1' }, '+=0.1');
  tl.set(letters[7], { innerText: '9' }, '+=0.1');
  return tl;
};

export default LoaderDate;
